<template>
  <div v-if="instrument" ref="chartWrapper">
    <div class="text-right mb-2" style="margin-top: -5px; ">
      <span class="text-info pointer mr-2" @click="switchPeriods()">
        <small>Afficher le graph {{ weekly ? "daily" : "hebdo" }}</small>
      </span>
      <span class="text-warning pointer" @click="switchIndicatorModal()">
        <small>Modifier les indicateurs</small>
      </span>
    </div>
    <trading-vue
      ref="tvjs"
      :data="chart"
      :extensions="ext"
      :overlays="overlays"
      :legend-buttons="[
        'display',
        'settings' /*'up', 'down', 'add', 'remove'*/
      ]"
      :titleTxt="instrument.na"
      :toolbar="this.chartSize.width > 400"
      :color-back="userConf.view.darkmode ? '#27293d' : '#fff'"
      :color-grid="userConf.view.darkmode ? '#2f3240' : '#eee'"
      :color-text="userConf.view.darkmode ? '#dedddd' : '#333'"
      :colorTbBack="userConf.view.darkmode ? '#27293d' : '#fff'"
      :colorTbBorder="userConf.view.darkmode ? '#2f3240' : '#eee'"
      :height="this.chartSize.height"
      :width="this.chartSize.width"
      @drawing-mode-off="saveDrawings"
      @remove-tool="removeTool"
    ></trading-vue>

    <modal
      :show.sync="indicatorsModal"
      class="modal-position"
      @close="selectInstrument(instrument)"
    >
      <div class="row">
        <div class="col-12">
          <h4 class="card-title">Modifier les indicateurs</h4>
        </div>
        <div class="col-12 text-left">
          <base-switch v-model="ind.trend">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">Indicateur de tendance</span>
          <br />

          <base-switch v-model="ind.gaps" v-if="this.mode !== 'crypto'">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">Trous de cotation</span>
          <br />

          <base-switch v-model="ind.mm7">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">Moyenne Mobile 7 périodes</span>
          <br />

          <base-switch v-model="ind.mm20">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">Moyenne Mobile 20 périodes</span>
          <br />

          <base-switch v-model="ind.mm50">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">Moyenne Mobile 50 périodes</span>
          <br />

          <base-switch v-model="ind.mm100">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">Moyenne Mobile 100 périodes</span>
          <br />

          <base-switch v-model="ind.mm200">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">Moyenne Mobile 200 périodes</span>
          <br />

          <base-switch v-model="ind.bb">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">Bandes de bollinger</span>
          <br />

          <base-switch v-model="ind.sar">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">SAR</span>
          <br />

          <base-switch v-model="ind.rsi">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">RSI</span>
          <br />

          <base-switch v-model="ind.ichi">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">Ichimoku</span>
          <br />
        </div>
        <div class="col-12 text-right">
          <base-button
            @click="applyIndicator()"
            type="primary"
            class="btn-fill btn-sm float-right"
          >
            Enregistrer
          </base-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { Modal, BaseSwitch } from "@/components";
import { TradingVue, DataCube } from "trading-vue-js";
import indicator from "../indicators/tfind_002.js";
import Overlays from "tvjs-overlays";
import {
  getQuoteWeeklyHistory,
  getQuoteDailyHistory,
  getDrawing,
  updateDrawings
} from "../dao/firestore";
import { mapGetters } from "vuex";
const SMA = require("technicalindicators").SMA;
import XP from "tvjs-xp";

export default {
  props: {
    instrument: {
      type: Object,
      default: () => {}
    },
    useConf: {
      type: Boolean,
      default: () => true
    }
  },
  components: {
    TradingVue,
    BaseSwitch,
    Modal
  },
  data() {
    return {
      ext: Object.values(XP),
      overlays: Object.values(Overlays),
      drawings: { uid: null },
      indicatorsModal: false,
      weekly: true,
      ind: {
        trend: true,
        gaps: false,
        mm7: false,
        mm20: false,
        mm50: false,
        mm100: false,
        mm200: false,
        bb: false,
        sar: false,
        ichi: false,
        rsi: false
      },
      getIn: false,
      chartSize: {
        width: 600,
        height:
          window.innerWidth > 400
            ? window.innerHeight - 200
            : window.innerHeight / 1.8
      },
      chart: new DataCube({
        chart: {
          data: [],
          indexBased: false
          // tf: '1D'
        },
        onchart: [],
        offchart: []
      })
    };
  },
  computed: {
    ...mapGetters({
      userConf: "auth/conf",
      user: "auth/user",
      mode: "auth/mode"
    })
  },
  methods: {
    removeTool: function() {
      setTimeout(async () => {
        await this.saveDrawings();
      }, 500);
    },
    saveDrawings: async function() {
      if (this.userConf.isPro) {
        const s = this.weekly ? "weekly" : "daily";
        this.drawings[s] = this.chart.data.onchart.filter(
          c =>
            !c.name.startsWith("MONI") &&
            !c.name.startsWith("MM") &&
            !c.name.startsWith("BB") &&
            !c.name.startsWith("SAR") &&
            !c.name.startsWith("RSI") &&
            !c.name.startsWith("Ichi")
        );
        await updateDrawings(this.drawings);
      }
    },
    setConf: function(weekly, newInds) {
      this.weekly = weekly;
      this.ind = newInds;
    },
    applyIndicator: function() {
      this.indicatorsModal = false;
      this.selectInstrument(this.instrument);
      if (this.useConf) {
        this.$store.dispatch("auth/updateconf", {
          ind: this.ind
        });
      }
    },
    switchPeriods: function() {
      this.weekly = !this.weekly;
      this.selectInstrument(this.instrument);
    },
    switchIndicatorModal: function() {
      this.indicatorsModal = true;
    },
    selectInstrument: async function(instrument) {
      if (
        this.user.uid &&
        instrument &&
        instrument.isin &&
        this.userConf.isPro
      ) {
        this.drawings = await getDrawing(this.user, instrument);
      }

      this.chart = new DataCube({
        chart: {
          data: [],
          indexBased: false
        },
        onchart: [],
        offchart: []
      });

      // Add user drawings
      const s = this.weekly ? "weekly" : "daily";
      if (this.drawings && this.drawings[s]) {
        for (const drawing of this.drawings[s]) {
          this.chart.add("onchart", {
            name: drawing.name,
            type: drawing.type,
            data: drawing.data,
            settings: drawing.settings
          });
        }
      }

      // Set current instrument
      this.$store.dispatch("instruments/select", instrument);

      // Start loading data in firebase
      let quotes = this.weekly
        ? await getQuoteWeeklyHistory(instrument)
        : await getQuoteDailyHistory(instrument);

      if (this.weekly) {
        this.chart.set("chart.indexBased", "false");
      } else {
        this.chart.set("chart.indexBased", "true");
      }
      this.chart.set("chart.data", quotes);

      if (quotes.length >= 2) {
        // todo : remove
        // Divide previous week volume by 5 to get avg exchange
        this.avgExchange = parseInt(
          ((quotes[quotes.length - 2][5] / 5) * quotes[quotes.length - 2][4]) /
            1000
        );
      }

      if (this.ind.trend) this.drawIndicator(quotes);
      if (this.ind.gaps) this.drawGaps(quotes);
      if (this.ind.mm7) this.drawMovingAverage(quotes, 7, "#1d8cf8");
      if (this.ind.mm20) this.drawMovingAverage(quotes, 20, "#00f2c3");
      if (this.ind.mm50) this.drawMovingAverage(quotes, 50, "#ff8d72");
      if (this.ind.mm100) this.drawMovingAverage(quotes, 100, "#fd5d93");
      if (this.ind.mm200) this.drawMovingAverage(quotes, 200, "#e14eca");
      if (this.ind.bb)
        this.chart.add("onchart", {
          name: "BB",
          type: "BB",
          data: {},
          settings: this.getPreset("BB") || {}
        });
      if (this.ind.sar)
        this.chart.add("onchart", {
          name: "SAR",
          type: "SAR",
          data: {},
          settings: this.getPreset("SAR") || {}
        });
      if (this.ind.rsi)
        this.chart.add("offchart", {
          name: "RSI",
          type: "RSI",
          data: {},
          settings: this.getPreset("RSI") || {}
        });
      if (this.ind.ichi)
        this.chart.add("onchart", {
          name: "Ichi",
          type: "Ichi",
          data: {},
          settings: this.getPreset("Ichi") || {}
        });

      this.$refs.tvjs.resetChart();
    },
    getPreset(type) {
      let proto = this.overlays.find(x => x.name === type);
      if (proto && proto.methods.meta_info) {
        let meta = proto.methods.meta_info();
        return meta.preset;
      }
    },
    drawGaps(quotes) {
      const gaps = [];
      let min = 99999999;
      let max = 0;
      // TOHLCV
      const rqts = quotes.slice().reverse();
      rqts.forEach((q, i) => {
        if (i) {
          const n = rqts[i - 1];
          // la valeur précédente à un cmax < nmin et cmax < min
          if (q[2] < n[3] && q[2] < min) {
            gaps.push({
              t: q[0],
              from: q[2],
              to: min
            });
          }
          // Ou la valeur précédente à un cmin > nmax et cmin > max
          if (q[3] > n[2] && q[3] > max) {
            gaps.push({
              t: q[0],
              from: q[3],
              to: max
            });
          }
        }
        max = Math.max(max, q[2]);
        min = Math.min(min, q[3]);
      });
      gaps.forEach(g => {
        this.chart.add("onchart", {
          name: "MONI-Gaps",
          type: "Channel",
          data: quotes
            .filter(x => x[0] >= g.t)
            .map(x => [x[0], g.from, g.from, g.to]),
          settings: {
            legend: false,
            showMid: false,
            backColor: "#ff8d7288",
            color: "#ff8d7288"
          }
        });
      });
    },
    drawMovingAverage(quotes, period, color) {
      let results = SMA.calculate({
        period: period,
        values: quotes.map(q => q[4])
      });
      this.chart.add("onchart", {
        name: "MM" + period,
        type: "Spline",
        data: results.map((q, i) => {
          return [quotes[i + period - 1][0], q];
        }),
        settings: {
          lineWidth: 2,
          color: color
        }
      });
    },
    drawIndicator(quotes) {
      const inds = [];
      const trend = [];
      let pv = 0;
      let fp = 0;
      let trendcount = 0;
      let trades = [];
      let position = { bd: null };
      for (let i = 0; i < quotes.length; i++) {
        const q = quotes[i];
        const quotesToUse = quotes.slice(0, i + 1);
        const ind = indicator.getIndications(quotesToUse, position);

        if (ind == null) continue;
        inds.push(ind);
        if (q[4] >= ind[1] && !position.bd) {
          const buyPrice = q[1] > ind[1] ? q[1] : ind[1];
          position = {
            bd: q[0],
            bp: buyPrice,
            st: Math.max(buyPrice * 0.85, q[3] * 0.95),
            bk: null
          };

          const previousTrend = trend.length ? trend[trend.length - 1] : null;
          const previousBegin =
            trend.length && previousTrend.data.length
              ? previousTrend.data[previousTrend.data.length - 1][0]
              : inds[i - 1][0];
          trend.push({
            name: "MONI-RED",
            type: "Channel",
            data: inds.filter(x => x[0] >= previousBegin),
            settings: {
              legend: false,
              backColor: "#4d070744",
              color: "#4d0707FF"
            }
          });
        } else if (q[3] < ind[3] && position.bd) {
          const previousTrend = trend.length ? trend[trend.length - 1] : null;
          const previousBegin =
            trend.length && previousTrend.data.length
              ? previousTrend.data[previousTrend.data.length - 1][0]
              : inds[i - 1][0];
          // Draw trend
          trend.push({
            name: "MONI-GREEN",
            type: "Channel",
            data: inds.filter(x => x[0] >= previousBegin),
            settings: {
              legend: false,
              backColor: "#074d1844",
              color: "#074d18FF"
            }
          });
          position.bd = null;
          position.bk = ind[1];
          position.st = ind[3];
        } else if (position.bd) {
          position.st = ind[3];
        } else if (!position.bd) {
          position.bk = ind[1];
        }

        // Finish drawing current trend
        if (i == quotes.length - 1) {
          const previousTrend = trend.length ? trend[trend.length - 1] : null;
          const previousBegin =
            trend.length && previousTrend.data.length
              ? previousTrend.data[previousTrend.data.length - 1][0]
              : inds[i - 1][0];
          trend.push({
            name: "MONI-END",
            type: "Channel",
            data: inds.filter(x => x[0] >= previousBegin),
            settings: {
              legend: false,
              backColor: position.bd ? "#074d1844" : "#4d070744",
              color: position.bd ? "#074d18FF" : "#4d0707FF"
            }
          });
        }
      }

      trend.forEach(t => {
        this.chart.add("onchart", t);
      });
    }
  },
  async mounted() {
    this.weekly = this.mode !== "crypto";
    if (this.userConf && this.userConf.ind) {
      this.ind = this.userConf.ind;
    }
    if (this.instrument) {
      this.selectInstrument(this.instrument);
      this.$nextTick(() => {
        this.chartSize.width = this.$refs.chartWrapper.getBoundingClientRect().width;
      });
    }
  },
  watch: {
    userConf(newValue, oldValue) {
      if (
        this.useConf &&
        newValue &&
        newValue != oldValue &&
        this.userConf.ind
      ) {
        this.ind = newValue.ind;
      }
    },
    instrument(newValue, oldValue) {
      if (newValue && newValue != oldValue) {
        this.selectInstrument(newValue);
        this.$nextTick(() => {
          this.chartSize.width = this.$refs.chartWrapper.getBoundingClientRect().width;
        });
      }
    }
  }
};
</script>
<style></style>
